import { useMemo } from 'react'
import {
  activeUserEmailInUse,
  activeUserLicensing,
  activeUserSuperAdmin,
  guestRoleName,
} from '@user/components/Settings/Users/UpdateUser/constants'
import { ITenantUser } from '@user/store/users'
import { useSelector } from 'react-redux'
import { selectLicenseInformation } from '@user/store/licensing/slice'

const useGetUserStatusToggleMsg = (
  user?: ITenantUser,
  emailIsUniqueSC?: boolean,
) => {
  const licenseInformation = useSelector(selectLicenseInformation)

  return useMemo(() => {
    if (
      Number(licenseInformation?.availableLicenses) <= 0 &&
      user &&
      !user.isActive &&
      user.roleName !== guestRoleName
    ) {
      return activeUserLicensing
    }

    if (user && user.isActive && user.isSuperAdmin) {
      return activeUserSuperAdmin
    }

    if (user && !user.isActive && !emailIsUniqueSC) {
      return activeUserEmailInUse
    }
  }, [licenseInformation?.availableLicenses, user, emailIsUniqueSC])
}

export default useGetUserStatusToggleMsg
